module.exports = __webpack_public_path__ + "img/weary_face.84438700.gif";